export const getCurrencySymbol = (currency) => {
    if (!currency) return;
    switch (currency) {
        case 'EUR':
            return '€';
        case 'USD':
            return '$';
        case 'TRY':
            return '₺';
        default:
            return currency;
    }
};
